import { Component, OnInit, ElementRef, Injector, HostListener } from '@angular/core';
import { AccountService, IItem, ICoupon, IApiAccount, IFreeItem } from '../../services/account.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize, first, tap,map,publishReplay, refCount } from 'rxjs/operators';
import { CouponHelpers } from 'src/app/shared/helpers/coupon.helpers';
import { ItemHelpers } from 'src/app/shared/helpers/item.helpers';
import { ModalController, NavParams } from '@ionic/angular';
import { RedeemOfferModalComponent } from '../../modals/redeem-offer-modal/redeem-offer-modal.component';
import { SettingService } from 'src/app/shared/services/setting.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CouponsType } from '../../view-offer/view-offer.component';
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IBasePromotionRequest, IPromotions, PromotionService } from 'src/app/store/services/promotion.service';
import { ViewPromoOfferComponent } from 'src/app/shared/components/view-promo-offer/view-promo-offer.component';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconService } from 'src/app/shared/services/icon.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-offer-page',
    templateUrl: './offer-page.component.html',
    styleUrls: ['./offer-page.component.scss'],
    standalone: false
})
export class OfferPageComponent implements OnInit {
  title: string = 'Nav.Offers';
  offers: IItem[] = [];
  coupons: ICoupon[] = [];
  //promotions: IPromotions[]=[];
  promotions: any[] = [];
  primary: IApiAccount;
  couponsType = CouponsType;
  configs: any;

  promotionRequest: IBasePromotionRequest;

  valideNotification: number;
  AllNotifications: INotifications[];

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  get lang() {
    return this.translationService.getLanguage();
  }


  bellIcon: IconDefinition;

  getCurrentPath(): string {
    return this.router.url;
  }
  
  constructor(private account: AccountService,
    private loader: LoaderService,
    //private translateService: TranslateService,
    private modalCtrl: ModalController,
    public settingService: SettingService,
    private router: Router,
    private el: ElementRef,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    private injector: Injector,
    private analytics: AnalyticsService,
    public promoService: PromotionService,
    private iconService: IconService,
    private translationService: TranslationService) {
      this.bellIcon = this.iconService.getIcon('bell')!;
    }

  async ngOnInit() {

    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(!this.isPopup) {
      var currentUrl = this.getCurrentPath();
      localStorage.setItem('Stateurl', currentUrl);
    } else {
      localStorage.setItem('Stateurl', 'popup-offers');
    }

    this.analytics.UpdateLocation({url: "/account/my-orders", ispopup: this.isPopup},  true, false);

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

    if (!this.settingService.configuration.hideECouponProgram) {
    
        this.getCoupons(); 
      //this.coupons = JSON.parse(localStorage.getItem('coupons')) 
      //this is only for merchant supporting coupons
    }
    if (!this.settingService.configuration.hideMemberProgram) {
      // this.offers = JSON.parse(localStorage.getItem('offers'))
      this.tryGetOffers();  //This is only for programs supportings members
    } 

    if (window.innerWidth <= 550) { // follows the value of the modal
      this.mobile = true;

      if(this.settingService.configuration.uIoptions?.rewardsToPopup) {
        this.disableHeader = false;
      }
    } else {
      this.mobile = false;

      if(this.settingService.configuration.uIoptions?.rewardsToPopup) {
        this.disableHeader = true;
      }
    }

    /*
    if (window.innerWidth <= 1140) {
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
    */

    this.getAllPromotions();

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  ngOnDestroy()
  {
    this.el.nativeElement.remove()
  }

  getAllPromotions(){
    this.fetchPromotions().subscribe(async promotions => {
      this.promotions = [];

      this.promotions = promotions;
      
      for(var i = 0; i < promotions.length; i++){
        // inject the image URL in each promotions
        this.promotions[i].visualConfig['imgURL'] = await this.promoService.fetchImage(promotions[i].visualConfig.imgShortName);
        this.promotions[i].visualConfig['imgMobileURL'] = await this.promoService.fetchImage(promotions[i].visualConfig.imgMobileShortName);
      }

      console.log(promotions);
    });
  }

  fetchPromotions() {
    this.promotionRequest = {
      merchantId: this.settingService.getMerchantId(),
    }

    return this.promoService.getPromotions(this.promotionRequest);
  }

  displayValidation(): number {
    try {
      if(this.settingService.configuration.uIoptions?.unDockNavigationBar && !this.isPopup) {
        return 1;
      } else if(!this.settingService.configuration.uIoptions?.unDockNavigationBar && !this.isPopup) {
        return 2;
      } else if(this.settingService.configuration.uIoptions?.offersToPopup && this.isPopup) {
        return 3;
      }
    return 2;
    } catch (e) {
      return 2;
    }
    
  }

  getpromoImage(promotion){
    if(this.mobile) {
      if(promotion.visualConfig){
        if(promotion.visualConfig.imgMobileURL) {
          const url = promotion.visualConfig.imgMobileURL;
          return url;
        }     
      }
    } else {
      if(promotion.visualConfig){
        if(promotion.visualConfig.imgURL) {
          const url = promotion.visualConfig.imgURL;
          return url;
        }     
      }
    }
    
  }

  validatePresentation(promotion): boolean {
    // checks if the promotion is disabled
    if(!promotion.deactivatePromotion && !promotion.discountDetails.applyFromCodeRemoveOffers && !promotion.restrictions.visibilityRestrictions.guestsOnly ) {
      const now = this.toUtcMidnight(new Date());

      /////////////////////////////////////////////////////////
      // checks if expired first or if there's any expiration at all
      if(!promotion.validity?.noExpiration) {
        const expirationDate = this.toUtcMidnight(new Date(promotion.validity.expirationDate));

        if (now >= expirationDate) {
          return false;
        }
      }
      /////////////////////////////////////////////////////////


      // then check if we're within the activation period
      if (promotion.validity?.activationDate) {
        const activationDate = this.toUtcMidnight(new Date(promotion.validity.activationDate));

        if (activationDate <= now) {
          return true;
          
        } else {

          return false;
        }
      }
    }

    return false;
  }

  toUtcMidnight(date: Date): Date {
    return new Date(Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    ));
  }

  async goViewPromo(promotion) { 
      
    const modal = await this.modalCtrl.create({
      component: ViewPromoOfferComponent,
      cssClass: 'viewpromo-popup-model',
      componentProps: {
        promotionId: promotion.id,
        isMobile: this.mobile
        //disableHeader: true
      }
    });

  
    await modal.present();

    const { data } = await modal.onDidDismiss();
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 550) { // follows the value of the modal
      this.mobile = true;

      if(this.settingService.configuration.uIoptions?.offersToPopup) {
        this.disableHeader = false;
      }
    } else {
      this.mobile = false;

      if(this.settingService.configuration.uIoptions?.offersToPopup) {
        this.disableHeader = true;
      }
    }

    /*
    if (window.innerWidth <= 1140) { // follows the value of the modal
      this.mobile = true;
    } else {
      this.mobile = false;
    }

    if (window.innerWidth <= 800) { // follows the value of the modal
      //this.mobile = true;

      this.disableHeader = false;
    } else {
      //this.mobile = false;

      this.disableHeader = true;
    }
      */
  }


  private async tryGetOffers() {
    const loader = await this.loader.create();
    await loader.present();
    this.account.$primary
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((primary) => {
        this.primary = primary;
        this.getOffers();
      });
  }

  private async getOffers() {
    // ignore if doesn't have a primary account selected
    if (!this.primary) return;

    // get from cache because its already refresh on ion-menu
    const loader = await this.loader.create();
    await loader.present();
    this.account.getItems(this.primary.ApiAccountId, true)
      .pipe(finalize(() => {
        loader.dismiss();
      })
      )
      .subscribe(
        (data) => {
         this.offers = data;   
        });
  }

   private async getCoupons() {
    
     const loader = await this.loader.create();
     await loader.present();
     this.account.getCoupons()
       .pipe(finalize(() => {
         loader.dismiss();
       }),
       )
       .subscribe(
         (coupons) => {
         //fetch the redeemed coupons from the storage and remove them from the list here
            let allowedCoupons = [];
            let redeemedCoupons = [];

            let storageReedemedCoupons = localStorage.getItem('redeemedCoupon');

            if (typeof storageReedemedCoupons == "string") {
              redeemedCoupons = JSON.parse(storageReedemedCoupons);
            }

            coupons.forEach(coupon => {
              let found = false;
              for (let i = 0; i < redeemedCoupons.length; i++) {                    
                  if (coupon.Id == redeemedCoupons[i]) {
                    found = true;
                    break;
                  }
              }

              if (!found) {
                allowedCoupons.push(coupon);
              }
            });

            this.coupons = allowedCoupons;
         });
   }
   
  goView(id: number | string) { 
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
    
    this.router.navigateByUrl(`account/viewoffer/${id}`);
  }

  // linkCoupons(id){
    
  //           this.account.linkCoupons(id).pipe(
  //           publishReplay(1), 
  //           refCount()).subscribe(res=>{
  //            localStorage['linkCoupon']=res;
  //           })
  //       }

  


  getCouponTranslationName(coupon: any) {

    if(localStorage['lang'] == 'fr')
    {
    
        return coupon.fr ? coupon.fr.Name : coupon.en.Name;
    }
    else
    {
      return coupon.en ? coupon.en.Name : coupon.fr.Name;
    }
    
  }
  
  getOfferImage(item: IItem): string {
    if(item.Choices) {
      var showConsole = false;
      for(var i = 0; i < item.Choices.length; i ++) {
        if(item.Choices[i].ImageUrl) {
          showConsole = true;
        }
      }

      if(showConsole) {
        console.log(item);
      }
    }
    
    return ItemHelpers.getOfferImage(item);
  }

  async onOfferClicked(offer: IItem) {
    /*this.navCtrl.setRoot(Redeem, {
        offer: offer
    });*/
    const modal = await this.modalCtrl.create({
      component: RedeemOfferModalComponent,
      componentProps: {
        primary: this.primary,
        offer: offer
      }
    });

    await modal.present();
  }

  getCouponName(coupon: ICoupon): string {
    return CouponHelpers.getName(coupon, this.lang);
  }

  getCouponTerms(coupon: ICoupon): string {
    return CouponHelpers.getTerms(coupon, this.lang);
  }

  getItemDescription(item: IFreeItem) {
    return ItemHelpers.getDescriptionTrans(item, this.lang);
  }

  getItemTerms(item: IFreeItem) {
    return ItemHelpers.getTermsTrans(item, this.lang);
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }
}
